<template>
   <div v-loading="loading"
        element-loading-custom-class="customClass"
        :element-loading-text="loadingTxt"
        class="step4">
   		<div class="" style="width: 80px;height: 80px;margin: 45px auto 35px">
   				<img src="@/assets/img/dataImport/dui.png" style="width:100%" alt="" srcset="">
   		</div>
   	<div>
   		<p class="p1">导入成功</p>
   		<p class="p2">导入成功人数共计{{this.formInline.total}}人</p>
   		<p style="margin-bottom: 6px" v-if="!step4Info.confirmBtn">如需查看数据详情或对导入数据进行调整，可点击<font  @click="toEditPage(step4Info.confirmBtn)">查看详情</font></p>
   		<p style="margin-bottom: 6px" v-if="step4Info.confirmBtn">如需查看数据详情,可点击<font  @click="toEditPage(step4Info.confirmBtn)">查看详情</font></p>
   		<p v-if="!step4Info.confirmBtn" style="padding-right: 82px">如需直接提交数据，请点击下方确认提交按钮</p>
   	</div>
   	<div style="margin-top: 90px;padding-bottom: 24px" v-if="!step4Info.confirmBtn">
   		<el-button type="primary" @click="_confirm">确认提交</el-button>
   		<!--<el-button type="primary" @click="_reloadButton">再次上传</el-button>-->
   	</div>


     <el-dialog
       ref=""
       id="dialog1"
       width="850px"
       v-dialogDrag
       :before-close="colseBeforeAction"
       :close-on-click-modal="false"
       :close-on-press-escape="false"
       title="温馨提示"
       @close="toEditPage(step4Info.confirmBtn)"
       :visible.sync="dialogheaderVisible"
     >
       <reminder :reminderList.sync="reminderList"></reminder>
       <div style="margin-top: 30px;text-align: center">
         <el-button
           type="primary"
           @click="toEditPage(step4Info.confirmBtn)"
         >
           确定
         </el-button>
       </div>
     </el-dialog>


<!--     <el-dialog-->
<!--       ref=""-->
<!--       id="dialog1"-->
<!--       width="850px"-->
<!--       v-dialogDrag-->
<!--       :close-on-click-modal="false"-->
<!--       :close-on-press-escape="false"-->
<!--       title="温馨提示"-->
<!--       :visible.sync="dialogheaderVisible2"-->
<!--     >-->
<!--       <reminder :reminderList.sync="reminderComputeList"></reminder>-->
<!--     </el-dialog>-->
<!--     <bspMask v-if="loading"><bspReminder :reminderList='reminderComputeList'></bspReminder></bspMask>-->
   </div>

</template>

<script>
  import {confirm} from "@/api/wage/batchTemplate.js"
  import reminder from "@/wage-components/bsp-reminder/bsp-reminder.vue";
  import {commonConst} from "@/const/code";
  import {calculateSalaryDetail} from "@/api/wage/batchTemplate";
  import Stomp from "stompjs";
  import store from "@/store";
  export default {
    name: "step4",
    components: {
      reminder
    },
    props: {
        step: {
        	type: String,
        	default: '',
        },
      step4Info: {
          type: Object,
          default: {},
        },
      formInline: {
          type: Object,
          default: {},
        },
      batchInfoDetail:{//父页面传入的批次信息
        type: Object,
        default: {}
      }
    },
    data() {
      return {
        reminderList:{
          title:'温馨提示',
          list:[],//'数据准备','薪资计算','生成发薪报税数据','发薪','报税','查看结果'
          current:0
        },
        // reminderComputeList:{
        //   title:'温馨提示',
        //   list:['请求计算','计算中','计算完成'],//'数据准备','薪资计算','生成发薪报税数据','发薪','报税','查看结果'
        //   current:0
        // },
        dialogheaderVisible:false,
        dialogheaderVisible2:false,
        computeResultState:'0',// 计算结果状态
        computeResultMsg:'待计算',//批次计算过程中的提示信息
        loadingTxt:'',
        loading:false,
      };
    },
    methods: {
      //检查是否包含某 procId
      checkSegList(procId){
        let list = ['proc_0007','proc_0008','proc_0009'];
        return list.findIndex(val=>val==procId)>-1
      },
      toEditPage(onlyPay) {
        if (onlyPay) {//仅工资条跳转
          let query = {
            batchId: this.step4Info.batchId,
            templateId: this.step4Info.templateId,
          }
          console.log("编辑参数query=", query);
          this.$router.push({
            path: '/payrollSettings/wageBatchInfoGroupTable',
            query
          });
        } else {
          const query = {
            templateId: this.step4Info.templateId,
            batchId: this.step4Info.batchId,
            region: this.formInline.region,
            payGroupId: this.formInline.payGroupId,
            payWay: this.formInline.payWay,
            wageMonth: this.batchInfoDetail.wageMonth,
            socMonth: this.batchInfoDetail.socMonth,
            taxMonth: this.batchInfoDetail.taxMonth,
            orgId: this.formInline.orgId,
            isCompute: this.formInline.isCompute,
            regionId: this.formInline.region,
            isHistoryFlag: 'false',//不查询历史
            hasCiicSegName:this.checkSegList(this.formInline.procNum)?1:0
          }
          console.log("第四步参数=", query);
          this.$router.push({path: '/wage/salaryDetailTabs', query});
        }
      },
      upStep(){
        this.$emit('update:step', 'step3')
      },
      colseBeforeAction(){
        //关闭返回上一页面
        //this.$router.go(-1)
        alert("quern==========close")
      },
      //将选中的数据发送到计算中心
      calculateCheckedData(batchId,params){
        this.loading = true;
        this.loadingTxt = '请求计算';
        this.dialogheaderVisible=false
        // this.dialogheaderVisible2 = true
        // Vue.$set(this.reminderList,'current',0)
        let obj={
          batchId: batchId
        };
        calculateSalaryDetail(obj).then(res=>{
          let rs=res.data
          if(rs.code==0){
            this.loading = true;
            // this.loadingTxt = rs.msg;
            this.loadingTxt = "计算中，请稍后";
            this.computeResultState = "ING";
            this.computeResultMsg = "计算中，请稍后";
            this.connect(batchId,params);
          }else{
            this.loading = false;
            this.$message.error(rs.msg);
          }
        });
      },
      _confirm(){
        // alert("batchId======"+this.step4Info.batchId)
        //调用提交接口

        this.$confirm('将针对整个批次进行提交，是否确认提交?','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=>{
          var params = JSON.parse(JSON.stringify(this.formInline))//转换成json对象传
          this.confirmProcess(params);

        });
      },
      _reloadButton(){
        /*this.$router.push({ path: '/wage/data-ready-template'});*/
        this.$emit('update:step', 'step1')
      },
      confirmProcess(params){
          if(this.computeResultState=="ING"){
              this.$message.error(this.computeResultMsg+",暂不能提交");
              return;
          }
          if(this.computeResultState=="FAIL"){
              this.$message.error(this.computeResultMsg+",请按要求修改批次数据，并重新计算后，再进行提交");
              return;
          }
        this.loading = true;
        confirm(params).then(res=>{
          this.loading = false;
          let re = res.data
          if(re.code == 0){
            if(re.data.isCompute && re.data.isCompute==commonConst.YES){//需要先计算的情况
              this.calculateCheckedData(this.step4Info.batchId,params);//前台计算显示流程及调用接口
              return
            }//需要先计算的情况
            if(re.data.segNum && re.data.segNum!=null){
              this.dialogheaderVisible=true;
              //alert("流程编码======"+JSON.stringify(re.data));
              let i = 0;
              re.data.cusProcess.segList.forEach(item=>{
                i+=1;
                if(this.reminderList.list.length!=re.data.cusProcess.segList.length){
                  this.reminderList.list.push(item.segName);
                }
                if(item.segNum==re.data.segNum){
                  this.reminderList.title='批次数据已提交，下一环节【'+item.segName+'】，批次明细查询，请【点此】，如需再次上传，请点【再次上传】';
                  this.reminderList.current = i-1;
                  return;
                }
              });
            }else{
              this.$message.success("操作完成");
              // 跳转到薪酬历史菜单
              // this.$router.push('/wage/wageHistory');
            }
          }
        })
      },
        //获取计算结果
        connect(batchId,params){
            this.$set(this.reminderList,'current',1)
            let baseUrl = process.env.VUE_APP_BASE_URL;
            // let baseUrl = process.env.VUE_APP_BASE_URL;
            //建立连接对象
            // let socket = new SockJS(baseUrl+"/wage/ws");
            let socket = new SockJS("/api/wage/ws");
            // 获取STOMP子协议的客户端对象
            this.stompClient = Stomp.over(socket);
            //将socket对象存在session里
            // sessionStorage.setItem("stompClient", this.stompClient);
            this.stompClient.debug = null
            // 定义客户端的认证信息,按需求配置
            let headers = {
                'Authorization': 'Bearer ' + store.getters.accessToken
            };
            // 向服务器发起websocket连接
            this.stompClient.connect({headers}, frame => {
                console.log("websocket 连接成功");
                this.isEnable = true
                //所有的消息订阅都要在connect中完成
                // let toId = store.getters.userInfo.userId+""+this.listQuery.batchId;
                let toId = store.getters.userInfo.userId+""+batchId;
                this.stompClient.subscribe('/user/' + toId + '/queue/wageCal/result/', msg => {
                    debugger
                    this.$set(this.reminderList,'current',2)
                    // this.loadingTxt = "计算完成";
                    this.loading = false;
                    console.log("接收到的消息：" + JSON.stringify(msg))
                    let message1 = msg.body
                    console.log(message1)
                    let resultState = message1.split("####")[0];
                    let resultMsg = message1.split("####")[1];
                    this.computeResultState = resultState;
                    this.computeResultMsg = resultMsg;
                    this.$message.success(resultMsg);

                    if(resultState=='SUCCESS'){
                        this.confirmProcess(params);
                    }
// 										console.log(this.$refs['forms'+this.index])
//                     this.$refs['forms'+this.index]._getItemDataList();
//                     this.$router.go(0);//刷新当前页
                })
            })
        },
    }
  };
</script>

<style scoped >
   .step4>div{
   	text-align: center;
   }
   .step4>div p{
   	font-size:13px;
   	font-family:PingFangSC-Regular,PingFang SC;
   	font-weight:400;
   	color:rgba(51,51,51,1);
   	line-height:18px;
   }
   .step4>div .p1{
   	font-size:15px;
   	font-family:PingFangSC-Regular,PingFang SC;
   	font-weight:400;
   	color:rgba(51,51,51,1);
   	line-height:21px;
   }
   .step4>div .p2{
   	font-size:12px;
   	font-family:PingFangSC-Regular,PingFang SC;
   	font-weight:400;
   	color:rgba(102,102,102,1);
   	line-height:17px;
   	margin: 5px 0 80px;
   }
   .el-loading-spinner{
     display: block;
   }
	 .step4>div p font{
	 color: #0EA5E5;
	 padding: 0 4px;
	 cursor: pointer;
	 }
</style>
